import { FormError } from "@3gaam/shared/types/error";
import { Moment } from "moment";
import React, {
  MutableRefObject,
  useCallback,
  useEffect,
  useState,
} from "react";
import DatePicker, { DatePickerProps } from "react-datepicker2";
import Icon from "../icon";

type onChangeType = {
  target: {
    name: string | null | undefined;
    value: Moment;
    type: string;
  };
};

type Props = Omit<DatePickerProps, "onChange"> & {
  error: FormError;
  children?: React.ReactNode;
  icon?: string;
  disabled?: boolean;
  name?: string | null;
  placeholder?: string;
  onChange?: (data: onChangeType) => void;
  containerClassName?: string;
  pickerRef?: MutableRefObject<DatePicker | undefined>;
};

const DatePickerField = ({
  onChange,
  value,
  max,
  className = "",
  icon,
  children,
  disabled,
  error,
  name,
  placeholder,
  containerClassName,
  styles,
  pickerRef,
}: Props) => {
  const handleChange = useCallback(
    (val: Moment) => {
      if (!onChange) return;
      let returnValue = {
        target: {
          name: name,
          value: val,
          type: "text",
        },
      };
      onChange(returnValue);
    },
    [name, onChange],
  );

  // need this delay to have ref updated
  // using ref to prevent update on blur!
  let [changed, setChanged] = useState<Moment | undefined>(undefined);
  useEffect(() => {
    if (!changed) return;
    let timeout = setTimeout(() => {
      if (!changed) return;
      handleChange(changed);
    }, 100);

    return () => {
      clearTimeout(timeout);
    };
  });

  let showError = name && error?.hasError && error?.dataError?.[name];
  return (
    <>
      <div
        className={`inp-box ${
          showError ? "invalid-field" : ""
        } ${containerClassName}`}
        style={{ zIndex: 4 }}
      >
        {icon && (
          <span className="inp-icon" style={{ pointerEvents: "none" }}>
            <Icon name={icon} />
          </span>
        )}
        <DatePicker
          //@ts-ignore
          ref={pickerRef}
          // @ts-ignore
          placeholder={placeholder}
          className={`form-control ${icon ? "pl-5" : ""} ${className}`}
          persianDigits={false}
          onChange={(val) => {
            setChanged(val);
          }}
          value={value}
          max={max}
          isGregorian={false}
          timePicker={false}
          calendarStyles={{ zIndex: 5 }}
        />
        {children}
      </div>
      {showError && name && (
        <p className="text-red font-12 mt-1">{error?.dataError?.[name]}</p>
      )}
    </>
  );
};

DatePickerField.defaultProps = {
  onChange: undefined,
  name: undefined,
  value: undefined,
  max: undefined,
  placeholder: undefined,
  className: "",
  icon: undefined,
  children: undefined,
  disabled: undefined,
  error: undefined,
};
export default DatePickerField;
